<template>
  <div
    class="success"
    :style="'height:' + (fullHeight-102) + 'px;'"
  >
    <!-- 头图 -->
    <div class="headImgs">
      <img src="../../assets/imgs/apply/bg.png">
    </div>
    <div class="title">
      <img src="../../assets/imgs/apply/loan_success.png">
      <div>
        <img
          class="icon"
          src="../../assets/imgs/apply/success_icon.png"
        >
        <p>您的需求已推送至平台合作金融机构，将会有业务人员通过您的账号预留电话联系您。</p>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      fullHeight: document.documentElement.clientHeight
    };
  },
  watch: {
    fullHeight (val) {//监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }

    }
  },
  mounted () {
    this.get_bodyHeight()
  },
  methods: {
    get_bodyHeight () {//动态获取浏览器高度
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight
          that.fullHeight = window.fullHeight
        })()
      }
    }
  }

}
</script>

<style lang="less" scoped>
.success {
  background-color: #fff;
  .headImgs {
    img {
      width: 100%;
    }
  }
  .title {
    margin-top: 34px;
    text-align: center;
    img {
      width: 722px;
      height: 30px;
    }
    div {
      margin-top: 60px;
      .icon {
        width: 137px;
        height: 137px;
      }
      p {
        height: 22px;
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2a2a2a;
        line-height: 22px;
        margin-top: 40px;
      }
    }
  }
}
</style>